import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-page-utilities',
  templateUrl: './landing-page-utilities.component.html',
  styleUrls: ['./landing-page-utilities.component.scss'],
})
export class LandingPageUtilitiesComponent implements OnInit {
  urlDownload = 'https://hi.fpt.vn/rev/lbq/736eyDgY';
  urlYCHT = 'https://hi.fpt.vn/rev/esv/mXqnvMDy';
  urlFacebook = 'https://www.facebook.com/hifpt.official/';
  ulrYoutube = 'https://www.youtube.com/@hifptfpttelecom2535';
  urlTiktok = 'https://www.tiktok.com/@hifptvn?_t=8iKoqnRtISP&_r=1';
  buttonDownload!: HTMLAnchorElement;
  buttonYCHT!: HTMLAnchorElement;
  buttonFacebook!: HTMLAnchorElement;
  buttonYoutube!: HTMLAnchorElement;
  buttonTiktok!: HTMLAnchorElement;
  isShowDownloadAppToast: boolean = true;
  constructor() {}

  ngOnInit(): void {
    window.addEventListener('DOMContentLoaded', () => {
      if (window.innerWidth > 1024) {
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
      }
    });

    this.handleMenu();
  }

  moveToDownload() {
    window.location.href = this.urlDownload;
  }

  moveToYCHT() {
    window.location.href = this.urlYCHT;
  }

  moveToFacebook() {
    window.location.href = this.urlFacebook;
  }

  moveToYoutube() {
    window.location.href = this.ulrYoutube;
  }

  moveToTikTok() {
    window.location.href = this.urlTiktok;
  }

  moveToHomeLandingPage() {
    window.location.href = '/landing-page-utilities';
  }

  handleCloseDownloadAppToast() {
    this.isShowDownloadAppToast = false;
  }

  handleMenu() {

    document.getElementById('close-toast')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.download-app-toast')?.classList.add('hide');
    });
    document.getElementById('open-menu')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.menu-mobile')?.classList.add('show');
    });
    document.getElementById('close-menu')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.menu-mobile')?.classList.remove('show');
    });
    document
      .querySelector('.menu-mobile .bg')
      ?.addEventListener('click', () => {
        document.querySelector('.menu-mobile')?.classList.remove('show');
      });
    document.querySelectorAll('.scroll-to').forEach((element) => {
      element.addEventListener('click', () => {
        document.querySelector('.menu-mobile')?.classList.remove('show');
        const target = element.getAttribute('data-target');
        if (target) {
          const targetElement = document.getElementById(target);
          if (targetElement) {
            window.scrollTo({
              top:
                target !== 'footer'
                  ? targetElement.offsetTop - 100
                  : targetElement.offsetTop,
              behavior: 'smooth',
            });
          }
        }
      });
    });
  }

  handleScroll() {
    const goscrollElements = document.querySelectorAll('.goscroll');
    goscrollElements.forEach((element) => {
      const htmlElement = element as HTMLElement;
      htmlElement.style.visibility = 'hidden';
      const bottom = element.getAttribute('data-bottom');
      const kc = bottom ? parseInt(bottom) : 80;
      const scrollPosition =
        (element as HTMLElement).offsetTop - window.innerHeight + kc;
      const fistanima = element.getAttribute('data-anitype');
      const childElements = element.children;
      for (let i = 0; i < childElements.length; i++) {
        let anima;
        if (fistanima) {
          anima = fistanima;
        } else {
          anima = childElements[i].getAttribute('data-anitype') || 'fadeIn';
        }
        if (window.pageYOffset > scrollPosition) {
          childElements[i].classList.add('animate__animated', anima);
          htmlElement.style.visibility = 'visible';
        } else {
          childElements[i].classList.remove('animate__animated', anima);
          htmlElement.style.visibility = 'hidden';
        }
      }
    });
  }
}
